import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import hubLogo from '../../assets/branding/logo_white.png';
import './style.scss';

const navItems = [
    { label: 'Retornar ao Dashboard', path: '/' },
    { label: 'Central de Administração', path: '/admin' },
    { label: 'Usuários', path: '/admin/usuarios' },
    { label: 'Campanhas', path: '/admin/campanhas' },
    { label: 'Contextos', path: '/admin/contextos' },
    { label: 'Chats', path: '/admin/chats' },
    { label: 'Controle de Notificações', path: '/admin/notificacoes' },
];

const primaryNav = navItems.slice(0, 2);
const secondaryNav = navItems.slice(2);

const HeaderAdmin: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <header className="header-admin">
            <div className="brand" onClick={() => navigate('/')}>
                <img src={hubLogo} alt="Hub Brasil" />
            </div>
            <ul className="menu menu-left">
                {primaryNav.map((item) => {
                    const isActive = location.pathname.startsWith(item.path);
                    return (
                        <li
                            key={item.label}
                            onClick={() => navigate(item.path)}
                            className={`menu-item ${isActive ? 'active' : ''}`}
                        >
                            {item.label}
                        </li>
                    );
                })}
            </ul>

            <div className="spacer" />

            <ul className="menu menu-right">
                {secondaryNav.map((item) => {
                    const isActive = location.pathname.startsWith(item.path);
                    return (
                        <li
                            key={item.label}
                            onClick={() => navigate(item.path)}
                            className={`menu-item ${isActive ? 'active' : ''}`}
                        >
                            {item.label}
                        </li>
                    );
                })}
            </ul>
        </header>
    );
};

export default HeaderAdmin;
